// import gemoji from 'gemoji';

export const availableLanguages = [
  { value: 'en', label: 'English', icon: "EN" }, /* gemoji.name.us.emoji */
  //{ value: 'de', label: 'German',   icon: "DE" }, /* gemoji.name.de.emoji */
];

/* availableDateformats: [
  { value: 'Y MMMM D', label: moment().format("Y MMMM D") + " (Y MMMM D)" },
  { value: 'Y-M-D', label: moment().format("Y-M-D") + " (Y-M-D)" },
  { value: 'Y.M.D', label: moment().format("Y.M.D") + " (Y.M.D)" },
  { value: 'Y/M/D', label: moment().format("Y/M/D") + " (Y/M/D)" },
  { value: 'D MMMM Y', label: moment().format("D MMMM Y") + " (D MMMM Y)" },
  { value: 'D-M-Y', label: moment().format("D-M-Y") + " (D-M-Y)" },
  { value: 'D.M.Y', label: moment().format("D.M.Y") + " (D.M.Y)" },
  { value: 'D/M/Y', label: moment().format("D/M/Y") + " (D/M/Y)" },
  { value: 'MMMM/D/Y', label: moment().format("MMMM/D/Y") + " (MMMM/D/Y)" },
  { value: 'M-D-Y', label: moment().format("M-D-Y") + " (M-D-Y)" },
  { value: 'M.D.Y', label: moment().format("M.D.Y") + " (M.D.Y)" },
  { value: 'M/D/Y', label: moment().format("M/D/Y") + " (M/D/Y)" },
] */
